
/**
 * https://developerx.atlassian.net/browse/CS-4943
 * 
 * Created at : 09 Feb 2022             Updated at : 09 Feb 2022
 * Created by : Risman Abdilah          Updated by : Risman Abdilah
 * 
 * Version 2.3.0
 */

import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface LanguageFormType {
  languageName: string;
  languageLevel: string;
}

@Component
export default class ModalLanguage extends Vue {
  /* VUEX */

  /* ACTION */

  /* PROP */
  @Prop({ default: false })
  private isShow: boolean;

  /* INITIALIZATION */
  private languageForm: LanguageFormType = {
    languageName: "",
    languageLevel: "",
  }

  private array_language: Array<any> = [];
  private array_language_level: Array<any> = [];

  /* METHODS */
  private onSubmit() {
    this.$emit("update:isShow", false);
  }

  private onInputLanguageName(lang: any) {
    // TODO
  }

  private onInputLanguageLevel(level: any) {
    // TODO
  }

  private getTranslation(label: string): string {
    if (this.$i18n.locale === "id") {
      return "translation";
    }
    return label;
  }
}
